if (!customElements.get('size-chart-drawer')) {
  class SizeChartDrawer extends SideDrawer {
    constructor() {
        super();
        this.blockParent = this.closest('variant-picker');
        this.sizeChartOpener = this.blockParent.querySelector('.js-size-chart-opener');
        this.handleDrawerOpenViaEvent();
    }

    handleDrawerOpenViaEvent() {
        document.body.appendChild(this);
        this.sizeChartOpener.addEventListener('click', () => {
            this.open();
        });
    }
  }

  customElements.define('size-chart-drawer', SizeChartDrawer);
}